import { gql } from "@apollo/client";

export const GET_PROCESS_AREA_SUMMARY_DASHBOARD = gql`
  query GetProcessAreaSummaryDashboard($uuid: ID!) {
    findAll: processAreaSummaryDashboard(uuid: $uuid) {
      locationPercentage
      children: procesess {
        locationPercentage
        revenueSupported
        name: process
        key: uuid
      }
      name: processArea
      revenueSupported
      underlyingProcesses
      key: uuid
    }
  }
`;
